import { Spinner } from '@chakra-ui/react';

export const LoadingSpinner = () => {
  console.info('spinner.tsx_1');

  return (
    <>
      <Spinner size="xl" />
      <div>Loading</div>
    </>
  );
};
